// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_t-2";
export var blackBorderOnHover = "_t-7";
export var cell = "_t-6";
export var cellContainer = "_t-3";
export var checked = "_t-8";
export var disabled = "_t-5";
export var featuredIconCellContainer = "_t-9";
export var featuredIconTextContainer = "_t-b";
export var featuredIconWrapper = "_t-a";
export var noBorder = "_t-c";
export var orangeSelectedRow = "_2z-3";
export var overflowableText = "_t-0";
export var overflowableTextContainer = "_t-1";
export var row = "_u-0";
export var rowCheckboxCell = "_t-4";
export var selectableTable = "_2z-2";